import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { HelpCircle } from 'lucide-react';

const HelpPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="glass-card-md p-8" data-testid="help-content">
          <div className="flex items-center mb-6">
            <HelpCircle className="w-10 h-10 text-blue-500 mr-3" />
            <h1 className="text-4xl sm:text-5xl tracking-tight font-semibold text-white">Yardım Merkezi</h1>
          </div>
          <div className="prose prose-slate max-w-none">
            <h2 className="text-2xl font-medium text-slate-800 mt-6 mb-3">Sıkça Sorulan Sorular</h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-medium text-slate-800 mb-2">Doktor Cebinde nedir?</h3>
                <p className="text-white/70">Doktor Cebinde, kişisel sağlık takip platformudur. Günlük durumunuzu kaydedebilir, asistanınızla konuşabilir ve ilerlemenizi takip edebilirsiniz.</p>
              </div>

              <div>
                <h3 className="text-lg font-medium text-slate-800 mb-2">Nasıl başlarım?</h3>
                <p className="text-white/70">Kayıt olduktan sonra onboarding sürecini tamamlayın. Bu süreçte sizin hakkınızda temel bilgiler toplanır ve AI asistanınız sizi daha iyi tanır.</p>
              </div>

              <div>
                <h3 className="text-lg font-medium text-slate-800 mb-2">Verilerim güvende mi?</h3>
                <p className="text-white/70">Evet, tüm verileriniz şifrelenir ve güvenli sunucularda saklanır. Gizlilik politikamızı okuyarak daha fazla bilgi edinebilirsiniz.</p>
              </div>

              <div>
                <h3 className="text-lg font-medium text-slate-800 mb-2">AI asistan tanı koyar mı?</h3>
                <p className="text-white/70">Hayır! AI asistanımız sadece destek ve yönlendirme sağlar. Tıbbi teşhis koymaz. Ciddi belirtilerde mutlaka bir sağlık profesyoneline danışın.</p>
              </div>

              <div>
                <h3 className="text-lg font-medium text-slate-800 mb-2">Test modülleri ne zaman aktif olacak?</h3>
                <p className="text-white/70">Test modülleri şu an placeholder olarak görünüyor. Bilimsel olarak geçerli testler yakında eklenecektir.</p>
              </div>

              <div>
                <h3 className="text-lg font-medium text-slate-800 mb-2">Hesabımı nasıl silebilirim?</h3>
                <p className="text-white/70">Profil ayarlarına giderek hesabınızı silebilirsiniz. Bu işlem tüm verilerinizi kalıcı olarak siler.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default HelpPage;